export const teamConstants = {
    GET_TEAM: 'GET_TEAM',
    GET_MEMBER: 'GET_MEMBER',
    CREATE_USER: 'CREATE_USER',
    DISABLE_USER: 'DISABLE_USER',
    SET_LOADING: 'SET_LOADING'
};